import { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Polyline, CircleMarker, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import api from '../../js/api';
import './Locations.scss';

function today() {
    return new Date().toISOString().slice(0, 10);
}

function formatDate(iso) {
    const d = new Date(iso);
    return d.toLocaleString('es-ES', { dateStyle: 'short', timeStyle: 'short' });
}

function StatsBar({ loc }) {
    if (!loc) return null;
    return (
        <div className="locations-stats">
            <div className="locations-stat"><span className="stat-label">Última</span><span>{formatDate(loc.recorded_at)}</span></div>
            <div className="locations-stat"><span className="stat-label">Batería</span><span>{loc.battery_level}%</span></div>
            <div className="locations-stat"><span className="stat-label">Velocidad</span><span>{loc.speed_kmh} km/h</span></div>
            <div className="locations-stat"><span className="stat-label">Altitud</span><span>{Math.round(loc.altitude)} m</span></div>
            <div className="locations-stat"><span className="stat-label">Precisión</span><span>{loc.accuracy} m</span></div>
        </div>
    );
}

export default function Locations() {
    const [start, setStart] = useState(today());
    const [end, setEnd] = useState('');
    const [locations, setLocations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [lastUpdated, setLastUpdated] = useState(null);

    function fetchLocations(s, e) {
        setLoading(true);
        setError(null);
        const path = e ? `/user/locations/${s}/${e}` : `/user/locations/${s}`;
        api.get(path)
            .then(data => {
                console.log('--- locations response', data);
                if (data?.error) setError('Error cargando ubicaciones');
                else { setLocations(data || []); setLastUpdated(new Date()); }
            })
            .catch(() => setError('Error de red'))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        fetchLocations(start, end);
    }, []);

    function handleSearch() {
        fetchLocations(start, end);
    }

    const positions = locations.map(l => [l.lat, l.lon]);
    const latest = locations[locations.length - 1] || null;
    const center = latest ? [latest.lat, latest.lon] : [40.4168, -3.7038];

    return (
        <div id="locations">
            <div className="locations-controls">
                <div className="date-inputs">
                    <label>
                        <span>Desde</span>
                        <input type="date" value={start} onChange={e => setStart(e.target.value)} />
                    </label>
                    <label>
                        <span>Hasta</span>
                        <input type="date" value={end} onChange={e => setEnd(e.target.value)} />
                    </label>
                </div>
                <div className="date-shortcuts">
                    <button onClick={() => { setStart(today()); setEnd(''); fetchLocations(today(), ''); }}>Hoy</button>
                    <button onClick={() => {
                        const d = new Date(); d.setDate(d.getDate() - 1);
                        const s = d.toISOString().slice(0, 10);
                        setStart(s); setEnd(s); fetchLocations(s, s);
                    }}>Ayer</button>
                    <button onClick={() => {
                        const d = new Date(); d.setDate(d.getDate() - 7);
                        const s = d.toISOString().slice(0, 10);
                        setStart(s); setEnd(''); fetchLocations(s, '');
                    }}>7 días</button>
                </div>
                <button className="search-btn" onClick={handleSearch}>Buscar</button>
                <button className="refresh-btn" onClick={handleSearch} disabled={loading} title="Refrescar">
                    <span className="material-symbols-outlined">refresh</span>
                </button>
                {lastUpdated && <span className="last-updated">{lastUpdated.toLocaleTimeString('es-ES')}</span>}
            </div>

            {loading && <p className="locations-msg">Cargando...</p>}
            {error && <p className="locations-msg">{error}</p>}
            {!loading && !error && !locations.length && <p className="locations-msg">Sin ubicaciones para este periodo.</p>}

            {!loading && !error && locations.length > 0 && (
                <>
                    <MapContainer key={center.toString()} center={center} zoom={15} className="locations-map">
                        <TileLayer
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <Polyline positions={positions} color="#4a9eff" weight={3} opacity={0.7} />
                        {locations.map((loc, i) => (
                            <CircleMarker
                                key={i}
                                center={[loc.lat, loc.lon]}
                                radius={i === locations.length - 1 ? 8 : 4}
                                color={i === locations.length - 1 ? '#ff4a4a' : '#4a9eff'}
                                fillColor={i === locations.length - 1 ? '#ff4a4a' : '#4a9eff'}
                                fillOpacity={0.9}
                                weight={1}
                            >
                                <Tooltip>
                                    <div>
                                        <strong>{formatDate(loc.recorded_at)}</strong><br />
                                        {loc.speed_kmh} km/h · {Math.round(loc.altitude)} m · {loc.battery_level}%
                                    </div>
                                </Tooltip>
                            </CircleMarker>
                        ))}
                    </MapContainer>
                    <StatsBar loc={latest} />
                </>
            )}
        </div>
    );
}